// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const ContactListsAPI = {
    Create(fn, req) {
        return fn(`/phone/contacts/contact-lists`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    List(fn, req) {
        return fn(`/phone/contacts/contact-lists?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["contactListId"], "contactListId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/contact-lists/${req["contactListId"]}?${fm.renderURLSearchParams(req, ["contactListId"])}`, { method: "GET" });
    },
    Update(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["contactList"]) === null || _a === void 0 ? void 0 : _a["id"], "contactList.id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/contact-lists/${(_b = req["contactList"]) === null || _b === void 0 ? void 0 : _b["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["contactListId"], "contactListId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/contact-lists/${req["contactListId"]}?${fm.renderURLSearchParams(req, ["contactListId"])}`, { method: "DELETE" });
    },
    ReplaceContacts(fn, req) {
        try {
            fm.validateUrlParam(req["contactListId"], "contactListId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/contact-lists/${req["contactListId"]}/contacts`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListContacts(fn, req) {
        try {
            fm.validateUrlParam(req["contactListId"], "contactListId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/contact-lists/${req["contactListId"]}/contacts?${fm.renderURLSearchParams(req, ["contactListId"])}`, { method: "GET" });
    },
    ReplaceDevices(fn, req) {
        try {
            fm.validateUrlParam(req["contactListId"], "contactListId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/contact-lists/${req["contactListId"]}/devices`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListDevices(fn, req) {
        try {
            fm.validateUrlParam(req["contactListId"], "contactListId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/contact-lists/${req["contactListId"]}/devices?${fm.renderURLSearchParams(req, ["contactListId"])}`, { method: "GET" });
    },
};
